module.exports = __webpack_public_path__ + "b15c6e5507f7f153650601b54d6a4204.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/12_column_medium_x1/public/news/anything.jpg
// module id = 282
// module chunks = 0